import { all, fork } from "redux-saga/effects";
import DeviceSaga from "./device-saga";
import ReportSaga from "./report-saga";
import EventSaga from "./event-saga";
import sitesSaga from "./sites-saga";
import KnowiSaga from "./knowi-saga";
import CVAppSaga from "./cvapp-saga";
import RoiSaga from "./roi-saga";
import UserAccountSaga from "./userAccount-saga";
import WidgetSaga from "./widget-saga";
import LicenseSaga from "./license-saga";
import ErrorSaga from "./error-saga";
import cameraOnboardingSaga from "./camera-onboaring-saga";
import ChatbotSaga from "./chatbot-saga";
import AssistantPromptsSaga from "./assistantPrompts-saga";
import ForensicSearchSaga from "./forensicSearch-saga";
import enrolledAppearanceSaga from "./ea-saga";
import AlertsSaga from "./alerts-saga";

export default function* rootSaga() {
  yield all([
    fork(ChatbotSaga),
    fork(AssistantPromptsSaga),
    fork(LicenseSaga),
    fork(DeviceSaga),
    fork(ReportSaga),
    fork(EventSaga),
    fork(sitesSaga),
    fork(KnowiSaga),
    fork(CVAppSaga),
    fork(RoiSaga),
    fork(UserAccountSaga),
    fork(WidgetSaga),
    fork(ErrorSaga),
    fork(cameraOnboardingSaga),
    fork(ForensicSearchSaga),
    fork(enrolledAppearanceSaga),
    fork(AlertsSaga),
  ]);
}
